import { DialogOldDesign } from './DialogOldDesign/Dialog';
import { DialogUiRedesign } from './DialogUiRedesign/Dialog';
import type { IDialogProps } from './types';

export function Dialog(props: IDialogProps) {
  if (props.newDialogStyleEnabled) {
    return <DialogUiRedesign {...props} />;
  } else {
    return <DialogOldDesign {...props} />;
  }
}
